import React from 'react';
import { CenteredLoader, PageContainer } from '@zignaly-open/ui';

export const zigSuspenseFallback = (
  <PageContainer>
    <CenteredLoader />
  </PageContainer>
);
